import { passCodes } from '../passCodes';
import audio from '../../../../assets/audio/kids-tracks/Text20.mp3';

export const step26door = {
    id: 26,
    title: 'Vrata',
    taskText: `
        <p>
            A ejhle, další duch. A tenhle má na sobě nějaký dlouhý hábit, to bude asi nějaký strašák. 
            Dobrý den, nevíte náhodou, proč se to tady jmenuje Zelená hora? A kdo že to vlastně jste? Opat Vejmluva? 
            Tak toho já ale neznám. Podle toho, jak důležitě to řekl bych ho ale asi znát měl. 
        </p>
        <p>           
            Žil tu v době kdy se to tu jmenovalo Černý les, o kterém nám říkal mušketýr. Vejmluva ale věděl, 
            že toto místo je svaté, tak nechával stromy vykácet a místo nich nechal postavit tenhle kostel. 
            Víc už neví. Nevíte pane opate, kdo by o této hoře mohl vědět víc? Kdo by nám prozradil, proč se jmenuje Zelená hora?
        </p>
        <p>
            Prý nám to řekne, ale musíme prvně správně odpovědět na následující otázky.
        </p>
    `,
    cipher: {
        text: `
            <p>
                <b>1. otázka ze 4:</b>
            </p>
            <p>
                Kde odpočívají zesnulí?
            </p>
        `,
        label: 'Úkol',
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[9],
    additionalInfo: 'Odpovědí je jedno slovo',
    points: false,
    audio: audio,
    hints: [
        {
            text: 'Správná odpověď je hřbitov',
        },
    ],
};
